import { Table } from '@getsynapse/design-system';
import classNames from 'classnames';
import TableSkeletonLoader from 'Organisms/TableSkeletonLoader/TableSkeletonLoader';
import DrillTableHeaderFilters from 'Pages/DashboardsDetailsPage/components/DrillTableHeaderFilters';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { insightDrilldownMetadataSelectors } from 'state/normalized/insightDrilldownMetadata/insightDrilldownMetadataSlice';
import drilldownSelectors from 'state/normalized/insights/drilldownSelectors';
import EventDrillDownTableBody from './EventDrillDownTableBody/EventDrillDownTableBody';
import EventDrillDownTableHeader from './EventDrillDownTableHeader/EventDrillDownTableHeader';
import { SortingType } from 'utils/customTypes';
import { RootState } from 'state/store';
import { handleEventExportData } from 'Pages/DashboardsDetailsPage/components/DrillDownSidePanel/drillDownDataExportHandlers';

const EventDrillDownTable = () => {
  const [orderByParam, setOrderByParam] = useState<string>('');
  const [order, setOrder] = useState<SortingType>('asc');
  const cardName = useSelector(
    drilldownSelectors.selectActiveDrilldownCardName
  );
  const isLoading = useSelector(
    insightDrilldownMetadataSelectors.selectIsActiveDrilldownLoading
  );
  const events = useSelector((state: RootState) =>
    drilldownSelectors.selectActiveDrilldownEventsSorted(
      state,
      orderByParam,
      order
    )
  );

  const handleSort = useCallback(
    (column: string) => {
      const isSameColumn = column === orderByParam;
      const newOrder: SortingType =
        isSameColumn && order === 'asc' ? 'desc' : 'asc';
      setOrderByParam(column);
      setOrder(newOrder);
    },
    [orderByParam, order]
  );

  const exportEvents = () => {
    handleEventExportData(events);
  };

  return (
    <div>
      <DrillTableHeaderFilters
        title={cardName}
        exportEnabled={!isLoading && events.length > 0}
        onExportClick={exportEvents}
      />
      <div className='w-full rounded-b overflow-auto border border-neutral-lighter-two max-h-filtered-table-body'>
        {isLoading && <TableSkeletonLoader />}
        {!isLoading && (
          <Table
            className={classNames('relative', {
              'max-w-full border-0 w-full': events.length,
              'w-full': !events.length,
            })}
            canSelectRows={false}
            data={{
              headData: {
                stickyHeader: true,
                handleSort,
                headCells: [],
              },
              rows: [],
              total: events.length,
            }}
            data-cy='team-dashboards-table'
          >
            <EventDrillDownTableHeader handleSort={handleSort} />
            <EventDrillDownTableBody events={events} />
          </Table>
        )}
      </div>
    </div>
  );
};

export default EventDrillDownTable;
